import $ from 'jquery';
import init from './init';
import { frame } from './utils/drawing';
import { Pjax, Prefetch, Dispatcher, BaseTransition } from 'barba.js';
import showBody from './showBody';

const metadataMap = {};

/**
 * Gets the "metadata" from the next page.
 * In this case, it's a custom JSON script tag for passing custom settings that can be intercepted by the Javascript.
 * For example, you can pass an array of HTML classes to be added to the HTML element, where previous page classes are
 * removed automatically.
 *
 * NOTE: Currently this metadata must exist within the Barba container element. TODO Support any location on the page.
 *
 * @param container
 * @returns Object
 */
function getMetadata(container) {
	const $metadata = $(container).find('script[data-pjax-metadata]');
	let metadata;

	try {
		metadata = JSON.parse($metadata.text());
	} catch(e) {
		metadata = {};
	}

	return metadata;
}

/**
 * Initialises the metadata settings for the page.
 *
 * @param metadata
 * @param oldMetadata
 */
function initMetadata(metadata={}, oldMetadata={}) {
	for (let key of Object.keys(metadata)) {
		const value = metadata[key];

		if (typeof metadataMap[key] === 'object') {
			const { init } = metadataMap[key];

			if (typeof init === 'function') {
				init(value, oldMetadata[key]);
			}
		}
	}
}

/**
 * Destroys the metadata settings for the page.
 *
 * @param metadata
 * @param newMetadata
 */
function destroyMetadata(metadata={}, newMetadata={}) {
	for (let key of Object.keys(metadata)) {
		const value = metadata[key];

		if (typeof metadataMap[key] === 'object') {
			const { destroy } = metadataMap[key];

			if (typeof destroy === 'function') {
				destroy(value, newMetadata[key]);
			}
		}
	}
}

/**
 * Hook to register callbacks for metadata properties
 *
 * @param property
 * @param lifecycle
 */
export function addMetadataHook(property, lifecycle) {
	metadataMap[property] = lifecycle;
}

/**
 * Initialisation
 */
export default function() {
	const $head = $('head');
	const $scroll = $('html, body');
	const $header = $('#header');
	const $overlay = $('#overlay');

	/*
	 * Create the page transition.
	 */
	Pjax.getTransition = () => BaseTransition.extend({

		start() {

			Promise
				.all([ this.newContainerLoading, this.fadeOut() ])
				.then(() => setTimeout(() => this.fadeIn(), 200))
				.catch((e) => console.error('Error navigating page:', e));
		},

		fadeOut() {

			destroyMetadata(getMetadata(this.oldContainer), getMetadata(this.newContainer));

			return $overlay.fadeIn(400).promise();
		},

		fadeIn() {

			const headerHeight = $header.height();
			let scrollTop = 0;
			let $this = this;

			$scroll.each(function() {
				scrollTop = Math.max(scrollTop, $(this).scrollTop());
			});

			if (scrollTop > headerHeight) {
				$scroll.scrollTop(headerHeight);
			}

			$scroll.animate({ scrollTop: 0 }, { duration: 400 });

			initMetadata(getMetadata(this.newContainer), getMetadata(this.oldContainer));

			$(this.oldContainer).css('display', 'none');
			$(this.newContainer).css('visibility', '');

			init(this.newContainer);

			setTimeout(()=>{
				$overlay.fadeOut(400, () => {
					$overlay.css('display', 'none');
					$this.done();

					showBody();
				});
			}, 300)
		},
	});

	/*
	 * Run tagged scripts for the new page.
	 */
	let $prevScripts = $('script[data-pjax-script]');
	let firstRun = true;
	Dispatcher.on('newPageReady', function(currentStatus, prevStatus, newContainer, rawHtml) {
		if (!firstRun) {
			const $wrapper = $('<div>');
			$wrapper.html(rawHtml);

			const $scripts = $wrapper.find('script[data-pjax-script]');

			$prevScripts.remove();
			$prevScripts = $scripts;

			$head.append($scripts);
		} else {
			firstRun = false;
		}
	});

	/*
	 * Let's go!
	 */
	Pjax.Dom.wrapperId = 'content';
	Pjax.start();
	Prefetch.init();
}



// WEBPACK FOOTER //
// ./source/scripts/pjax.js